import { FormHelperText as MuiFormHelperText } from '@mui/material';
import type { FormHelperTextProps as MuiFormHelperTextProps } from '@mui/material/FormHelperText';
import type { SxProps, Theme } from '@mui/material/styles';
import type { ReactElement } from 'react';

export type FormHelperTextProps = MuiFormHelperTextProps;

export const FormHelperText = ({ sx, ...rest }: FormHelperTextProps): ReactElement => {
  const baseSx: SxProps<Theme> = (theme) => ({
    fontSize: theme.typography.body.fontSize,
    lineHeight: theme.typography.body.lineHeight,
  });
  const mergedSx: SxProps<Theme> = sx === undefined ? baseSx : ([baseSx, sx] as SxProps<Theme>);

  return <MuiFormHelperText {...rest} sx={mergedSx} />;
};
